export default __webpack_public_path__ + "imgs/170cfdb81854ed6c77384f343d6554c4.jpg";